import React from "react";
import flowers from "../data/bucheteMireasa";
import FlowerContainer from "../components/FlowerContainer";

const BucheteMireasa = () => {
  return (
    <FlowerContainer
      flowers={flowers}
      title="Buchete de mireasă"
      subtitle="Alege un buchet de mireasă realizat cu măiestrie, pentru un look elegant și armonios."
      storageKey="BUCHETE_MIREASA_SCROLL_POSITION"
    />
  );
};

export default BucheteMireasa;
